var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarTable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33353 3.4667C3.03898 3.4667 2.8002 3.70548 2.8002 4.00003V13.3334C2.8002 13.6279 3.03898 13.8667 3.33353 13.8667H12.6669C12.9614 13.8667 13.2002 13.6279 13.2002 13.3334V4.00003C13.2002 3.70548 12.9614 3.4667 12.6669 3.4667H3.33353ZM1.7002 4.00003C1.7002 2.82183 2.15532 2.3667 3.33353 2.3667H12.6669C13.8451 2.3667 14.3002 2.82183 14.3002 4.00003V13.3334C14.3002 14.5116 13.8451 14.9667 12.6669 14.9667H3.33353C2.15532 14.9667 1.7002 14.5116 1.7002 13.3334V4.00003Z",
    fill: "#2D6772"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.75 1C11.1642 1 11.5 1.29381 11.5 1.65625V3.84375C11.5 4.20619 11.1642 4.5 10.75 4.5C10.3358 4.5 10 4.20619 10 3.84375V1.65625C10 1.29381 10.3358 1 10.75 1Z",
    fill: "#2D6772"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 1C5.66421 1 6 1.29381 6 1.65625V3.84375C6 4.20619 5.66421 4.5 5.25 4.5C4.83579 4.5 4.5 4.20619 4.5 3.84375V1.65625C4.5 1.29381 4.83579 1 5.25 1Z",
    fill: "#2D6772"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6.5C2 6.22386 2.31603 6 2.70588 6H13.2941C13.684 6 14 6.22386 14 6.5C14 6.77614 13.684 7 13.2941 7H2.70588C2.31603 7 2 6.77614 2 6.5Z",
    fill: "#2D6772"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarTable);
export default __webpack_public_path__ + "static/media/calendar_table.27a0406922379f9926ef54d0b0ba231d.svg";
export { ForwardRef as ReactComponent };